import React from 'react';
import { IconArrowUpRight } from '../icons.js';
import './match-badge.css';

// Match percentage badge (Kaan, 5 Kasım 2026; Wrangle reference). Green only from 60 up and deepening with the
// percentage (60s light, 70s medium, 80+ solid); weak fits listed below 60 are neutral grey (KARARLAR ~13:15).
export const matchTone = value => value >= 80 ? 3 : value >= 70 ? 2 : value >= 60 ? 1 : 0;
export function MatchBadge({ value, label = 'eşleşme', size = 'sm', className = '' }) {
  if (!Number.isFinite(value)) return null;
  return <span className={`bs-match-badge ${className}`.trim()} data-tone={matchTone(value)} data-size={size} title={`%${value} ${label}`} aria-label={`%${value} ${label}`}>
    <IconArrowUpRight size={size === 'lg' ? 15 : 12} aria-hidden="true" /><span aria-hidden="true">%{value}</span>
  </span>;
}
